export default function (cId) {
  const canvas = document.getElementById(cId);
  const context = canvas.getContext('2d');
  const width = canvas.width = canvas.clientWidth;
  const height = canvas.height = canvas.clientHeight;

  // création d'un tableau
  const particle = [];
  const colors = [
    '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
    '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50',
    '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
    '#FF5722', '#795548',
  ];

  const drawScreen = () => {
    const size = 50;
    const pFontName = 'Lucida Sans Unicode';
    context.font = `${size}pt ${pFontName}`;
    context.fillText('', width / 2, 150);
    context.textAlign = 'center';
    context.globalAlpha = 1;
    for (let i = 0; i < particle.length; i++) {
      particle[i].draw();
    }
  };

  const update = () => {
    context.clearRect(0, 0, width, height);
    drawScreen();
    requestAnimationFrame(update);
  };

  update();

  const randomRange = (min, max) => min + (Math.random() * (max - min));

  const convertToRadians = (degree) => degree * (Math.PI / 180);

  for (let i = 0; i < 350; i++) {
    setTimeout(() => {
      particle.push({
        x: randomRange(0, canvas.width),
        y: height / 2,
        boxW: 3,
        boxH: 14,
        size: 3,

        spikeran: randomRange(3, 5),

        velX: randomRange(-8, 8),
        velY: randomRange(-50, -10),

        angle: convertToRadians(randomRange(0, 360)),
        color: colors[Math.floor(Math.random() * colors.length)],
        anglespin: randomRange(-0.2, 0.2),

        draw() {
          context.save();
          context.translate(this.x, this.y);
          context.rotate(this.angle);
          context.fillStyle = this.color;
          context.beginPath();
          // drawStar(0, 0, 5, this.boxW, this.boxH);
          context.fillRect((this.boxW / 2) * -1, (this.boxH / 2) * -1, this.boxW, this.boxH);
          context.fill();
          context.closePath();
          context.restore();
          this.angle += this.anglespin;
          this.velY *= 0.999;
          this.velY += 0.3;

          this.x += this.velX;
          this.y += this.velY;
          if (this.y < 0) {
            this.velY *= -0.2;
            this.velX *= 0.9;
          }
          if (this.y > height) {
            this.anglespin = 0;
            this.y = height;
            this.velY *= -0.2;
            this.velX *= 0.9;
          }
          if (this.x > width || this.x < 0) {
            this.velX *= -0.5;
          }
        },
      });
    }, 1);
  }
}
